/**
 * Fallback for public-facing business details. Live CMS values take precedence.
 * Do not add a founding year, privacy contact, social profile or certification
 * here without approval from the business owner.
 */
export const PUBLIC_BUSINESS = {
  name: 'UNIVERSO ORO S.r.l.',
  addressRome: 'Viale Eritrea, 88/94, 00199 Roma',
  streetRome: 'Viale Eritrea, 88/94',
  phone: '+39 06 86219969',
  email: 'info@universo-oro.it',
  vatNumber: '02089140517',
  reaNumber: 'AR-160913',
} as const;